import React, {Component} from 'react'
import {connect} from 'react-redux'

class DeleteProject extends Component {
    
    render() {

        const { onDelete } = this.props
        return (
            <div className="timer-switch">
              <button className="button button--default button--timer button--start-timer" onClick={onDelete}>
                <div className="button__text">
                  Delete Project
o                </div>
              </button>
            </div>
        )
    }
}

function mapStateToProps(state, props) {

    return {}

}
export default connect(mapStateToProps)(DeleteProject)



// WEBPACK FOOTER //
// ./src/components/DeleteProject.js